/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Save_FailedInputs */

const vi_shop_group_save_failed = /** @type {(inputs: Shop_Group_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không lưu được nhóm sản phẩm.`)
};

/**

* @param {Shop_Group_Save_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_save_failed = /** @type {((inputs?: Shop_Group_Save_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Save_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_save_failed(inputs)
});